<div class="terms-confirm-popup">
    <owc-modal-dialog #owcConfigModelDialog [visible]="true"  disable-backdrop-click [size]="'large'">
        <owc-component-header class="modal-header">
           {{i18n.TERMS_CONDITIONS.HEADER}}
        </owc-component-header>
         <div class="modal-content padd-16">
           
            <owc-typography [variant]="'body2'" class="padd-t-8 content">                
                {{infoContent}}
            </owc-typography>
        </div>
        <owc-component-footer slot="footer" class="modal-footer-cls bottom-border">
            <div class="footer-actions" slot="suffix">
                <owc-button
                    data-testid="terms-page-decline-btn"
                    (click)="onDecline()"
                    [variant]="'secondary'">
                    {{i18n.TERMS_CONDITIONS.DECLINE}}
                </owc-button>
                <owc-button data-testid="terms-page-accept-btn" (click)="onAccept()">
                    {{i18n.TERMS_CONDITIONS.ACCEPT}}</owc-button>
            </div>
        </owc-component-footer>
    </owc-modal-dialog>
</div>

